/*
 * @author Lemuel Raganas <lemuel.raganas@mediacorp.com.sg>
 **/

import Vue from "vue";
import MainStub from "@/libs/world-cup/MainStub";

export default class MainApp extends Vue {
  $config: MainStub;

  constructor(appconstructor: any, options?: MainStub) {
    super(appconstructor);
    this.$config = options;
  }
}
